/* MAIN */
import { Stack } from './methods/debugger.js';
const castArray = (value) => {
    return isArray(value) ? value : [value];
};
const castError = (error) => {
    if (error instanceof Error)
        return error;
    if (typeof error === 'string')
        return new Error(error);
    return new Error('Unknown error');
};
const { is } = Object;
const { isArray } = Array;
const isEqual = (a, b) => {
    if (a.length !== b.length)
        return false;
    for (let i = 0, l = a.length; i < l; i++) {
        const valueA = a[i];
        const valueB = b[i];
        if (!is(valueA, valueB))
            return false;
    }
    return true;
};
const isFunction = (value) => {
    return typeof value === 'function';
};
const isObject = (value) => {
    return (value !== null) && (typeof value === 'object');
};
const isSymbol = (value) => {
    return typeof value === 'symbol';
};
const noop = (stack, dispose) => {
    return;
};
const nope = () => {
    return false;
};
/* EXPORT */
export { castArray, castError, is, isArray, isEqual, isFunction, isObject, isSymbol, noop, nope };
